import { useEffect, useState } from "react";
import { createContext, useContext } from "react";
import { secondAxios } from "../../../../../../api/axios";
import { useParams } from "react-router-dom";

const ECSContext = createContext();
export const useECSContext = () => useContext(ECSContext);

function ECSContextProvider({ children }) {
  const { plantId } = useParams();

  const [currentTab, setCurrentTab] = useState(0);
  const [currentMrqNav, setCurrentMrqNav] = useState("Scope");
  const [currentPoNav, setCurrentPoNav] = useState("Attachments");

  const [ecsList, setEcsList] = useState([]);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedListRow, setSelectedListRow] = useState(null);
  const [mrqScope, setMrqScope] = useState([]);
  const [mrqNotes, setMrqNotes] = useState([]);
  const [mrqAttachments, setMrqAttachments] = useState([]);

  const onSelectNavItem = ({ item }) => {
    if (currentTab === 1) {
      setCurrentMrqNav(item.label);
    } else {
      setCurrentPoNav(item.label);
    }
  };

  const [tagMaterials, setTagMaterials] = useState([]);

  const getTagMaterials = async () => {
    // Dummy data for tag materials
    const res = await secondAxios.get("material/tagged/" + plantId);
    setTagMaterials(
      res?.data
        // ?.filter((m) => m?.mrqMaterials?.[0]?.id)
        .map((m) => {
          return {
            ...m.taggedMaterial,
            ...m,
            mrqNumber: m?.mrqMaterials?.[0]?.mrq?.mrqNumber || "",
            poNumber:
              m?.mrqMaterials?.[0]?.poMaterials?.[0]?.po?.poNumber || "",
            selectedVendors:
              m?.mrqMaterials?.[0]?.poMaterials?.[0]?.vendor?.name || "",
          };
        }) || [],
    );
  };

  useEffect(() => {
    getTagMaterials();
  }, []);
  return (
    <ECSContext.Provider
      value={{
        currentTab,
        setCurrentTab,
        currentMrqNav,
        currentPoNav,
        onSelectNavItem,
        ecsList,
        setEcsList,
        selectedListRow,
        setSelectedListRow,
        rowSelection,
        setRowSelection,
        mrqScope,
        setMrqScope,
        tagMaterials,
        mrqNotes,
        setMrqNotes,
        mrqAttachments,
        setMrqAttachments,
      }}
    >
      {children}
    </ECSContext.Provider>
  );
}

export { ECSContextProvider, ECSContext };
